#import "./StaffTrainingModuleSummaryFields.graphql"

mutation StartTrainingCourse($slug: String!) {
  startTrainingCourse(input: { slug: $slug }) {
    trainingCourse {
      id
      slug
      title
      summary
      posterUrl
      category {
        id
        name
      }
      mandatory
      started
      status
      dueOn
      daysLeft
      moduleCount
      completeCount
      nextModuleSlug
      moduleSlug
      modules {
        ...StaffTrainingModuleSummaryFields
      }
    }
  }
}
